import { Box, Skeleton } from '@mui/material'
import { TopologyWrapper, SidebarPanel, TreeArea } from './Styled'

const TopologyLoading = () => (
  <TopologyWrapper>
    <SidebarPanel isExpanded={false}>
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Skeleton variant="rounded" height={32} sx={{ borderRadius: '8px' }} />
        <Box sx={{ mt: 1 }}>
          <Skeleton variant="text" width="40%" sx={{ mb: 1 }} />
          {[1, 2, 3].map(i => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: '5px', pl: 2 }}>
              <Skeleton variant="circular" width={7} height={7} sx={{ flexShrink: 0 }} />
              <Skeleton variant="text" width={`${50 + i * 15}%`} />
            </Box>
          ))}
        </Box>
        <Box sx={{ mt: 1 }}>
          <Skeleton variant="text" width="35%" sx={{ mb: 1 }} />
          {[1, 2].map(i => (
            <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: '5px', pl: 2 }}>
              <Skeleton variant="circular" width={7} height={7} sx={{ flexShrink: 0 }} />
              <Skeleton variant="text" width={`${45 + i * 20}%`} />
            </Box>
          ))}
        </Box>
      </Box>
    </SidebarPanel>
    <TreeArea>
      <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="100%" height="100%" style={{ maxWidth: 600, maxHeight: 400 }}>
          <circle cx="50%" cy="50%" r={18} fill="#E5E7EB" />
          {[[-160, -100], [-160, 100], [0, -120], [0, 120], [160, -100], [160, 100]].map(([dx, dy], i) => (
            <g key={i}>
              <line x1="50%" y1="50%" x2={`calc(50% + ${dx}px)`} y2={`calc(50% + ${dy}px)`} stroke="#E5E7EB" strokeWidth={2} />
              <circle cx={`calc(50% + ${dx}px)`} cy={`calc(50% + ${dy}px)`} r={14} fill="#E5E7EB" />
            </g>
          ))}
        </svg>
      </Box>
    </TreeArea>
  </TopologyWrapper>
)

export default TopologyLoading
